module.exports = __webpack_public_path__ + "img/uid-token-btn.b4814ba5.png";